
<section class="taskmanagement">
  <div class="board">
    <Tab class="tab" :tabText="tabText" :defaultActiveIndex="$route.params.tabId" @onClick="onClickTab"></Tab>
    
    
    <div class="tabContent" v-if="$route.params.tabId == tabText[0].val">
      <div>
        <div class="tabHeader alignEnd">
          <div class="select-block">
            <div class="select-each">
              <div>{{t('__common.__group')}}</div>
              <multiSelect  v-model:selected="state.selectGroup" :placeholder="state.emptyStatus"
              @onChange="selectChange" :options="state.groupOption" :listWidth="'264'"
              :isError="false" :hasAll="$t('__g3p_m8t.__allGroup')"></multiSelect>
              <!-- <Select @onChange="selectChange"  v-model:selected="state.selectGroup"
                style="height: 42px;"></Select> -->
            </div>
            <div class="select-each">
              <div>{{t('__common.__model')}}</div>
              <multiSelect  v-model:selected="state.selectModel" :placeholder="state.emptyStatus"
              @onChange="selectChange" :options="state.modelOption" :listWidth="'274'"
              :isError="false" :hasAll="$t('__t4.__allModel')"></multiSelect>
            </div>
            <div class="select-each datePickerLocal">
              <div>{{t('__d4e_m8t.__implementDate')}}</div>
              <DatePickerLocal @changeDatePicker="changeDatePicker" :value="state.implementDate" ></DatePickerLocal>
            </div>
            <div class="select-each">
              <div>{{t('__d4e_m8t.__implementationStatus')}}</div>
              <multiSelect  v-model:selected="state.selectImStatus" :placeholder="state.emptyStatus"
              @onChange="selectChange" :options="state.imStatusOption" :listWidth="'264'"
              :isError="false" :hasAll="$t('__t4.__allStatus')"></multiSelect>
            </div>
          </div>
          <div class="right">
            <Button type="full" class="margin" @onClick="deleteFilter" colors="dark1"  h="mlg"
              theme="2" wd="ss" icon="asus_pacc_sw_ico_reset" ></Button>
            <Button type="full" @onClick="goFilter" colors="dark1"  h="mlg"
              theme="2" wd="sm" :text="t('__t4.__filter')"></Button>
          </div>
        </div>
        <hr>
        <div class="tabHeader ">
          <div>{{t('__t4.__filterResults')}}</div>
          <Button type="full" @onClick="deleteET" :disable="!state.list.length" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')" h="mlg"></Button>
        </div>

        <!--   -->
        <div class="tabMainBlock">
          <Table @onCheckEach="onCheckEach" @goTableLink="goTableLink"  @onCheckAll="onCheckAll" 
          :defaultCheck="state.defaultCheckIndexList" @tableSort="tableSort"
            :columns="exeListCol"  :data="state.exeListData"
            tablePadding="20" :checkBox="true">
            <template #custom="{data, row,index,title,text}">
              <div v-if="data.depiction_code || data.depiction_code == 0">{{t(title[text])}} [{{data.depiction_code}}] {{transferDepictionCode(ERRORDESC,data.depiction_code)}}</div>
              <div v-if="data.depiction_code == null">{{t(title[text])}} [code] {{t('__main.__error')}}</div>
            </template>
            <template #reportth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #report="{index, data, text}">
              <span class="editIcon" @click="report(data)"
              @keypress.enter="report(data)" :tabindex=" !text ? -1 : 0">
                <iCon iconClass="asus_proart_sw_ico_file_text" :class="{'noEdit': !text}"></iCon>
              </span>
            </template>
            <template #twoTypeTableDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #twoTypeTableData="{index, data, text, col}">
              <span class="specialCase" v-if="data.status == null" @click="clickTasksStatus(data, true)">
                {{data['newStatus']}}
              </span>
            </template>

            <template #modeColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modeColData="{index, data, text, col}">
              <span >
                {{modeCol(data, col)}}
              </span>
            </template>


            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyTask')}}</div>
            </template>
          </Table>


        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>


    <div class="tabContent" v-if="$route.params.tabId == tabText[1].val">
      <div>
        <div class="tabHeader alignEnd">
          <div class="select-block">
            <div class="select-each">
              <div>{{t('__common.__group')}}</div>
              <multiSelect  v-model:selected="state.selectGroup" :placeholder="state.emptyStatus"
              @onChange="selectChange" :options="state.groupOption" :listWidth="'264'"
              :isError="false" :hasAll="$t('__g3p_m8t.__allGroup')"></multiSelect>
            </div>
            <div class="select-each">
              <div>{{t('__common.__model')}}</div>
              <multiSelect  v-model:selected="state.selectModel" :placeholder="state.emptyStatus"
              @onChange="selectChange" :options="state.modelOption" :listWidth="'274'"
              :isError="false" :hasAll="$t('__t4.__allModel')"></multiSelect>
            </div>
            <div class="select-each datePickerWide">
              <div class="flex relative">
                <div>{{t('__d7d_n17r.__date')}}</div>  
                <div class="flex radioBlock">
                  <Radio  v-model:selected="state.executedDateType" value="0" :text="$t('__t4.__setDate')" :paddingLeft="6"></Radio>
                  <Radio  v-model:selected="state.executedDateType" value="1" :text="$t('__d4e_m8t.__upcomingCalibrationDate')" :paddingLeft="6"></Radio>
                </div>
              </div>
              <DatePickerLocal @changeDatePicker="changeDatePicker" :value="state.implementDate"></DatePickerLocal>
            </div>
          </div>
          <div class="right">
            <Button type="full" class="margin" @onClick="deleteFilter" colors="dark1"  h="mlg"
              theme="2" wd="ss" icon="asus_pacc_sw_ico_reset" ></Button>
            <Button type="full" @onClick="goFilter" colors="dark1"  h="mlg"
              theme="2" wd="sm" :text="t('__t4.__filter')"></Button>
          </div>
        </div>
        <hr>
        <div class="tabHeader ">
          <div>{{t('__t4.__filterResults')}}</div>
          <Button type="full" @onClick="deleteAP" :disable="!state.list.length" class="btn-inline" colors="dark1"
              theme="2" wd="sm" icon="asus_proart_sw_ico_delete" :text="t('__g3p_m8t.__delete')" h="mlg"></Button>
        </div>
        <div class="tabMainBlock">
          <Table @tableSort="tableSort"  @onCheckAll="onCheckAll"
            @onCheckEach="onCheckEach" @goTableLink="goTableLink" :dropdown="'dataInfo'"
            :columns="appListCol" :data="state.appListData" tablePadding="20" :checkBox="true"
            :defaultCheck="state.defaultCheckIndexList">
            <template #second="{index, data}">
              <div class="dataInfo">
                
                <div v-for="(each , i) in data.dataInfo">
                  <TableInfo :columns="setAppListColSub(each.col)" :data="each.data">
                  </TableInfo>
                </div>
              </div>
            </template>
            <template #modifyth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #modify="{index, data, text}">
              <span class="editIcon" @click="editApp(data)">
                <iCon iconClass="asus_proart_sw_ico_edit_1"></iCon>
              </span>
            </template>


            <template #repeatColDatath="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #repeatColData="{index, data, text, col}">
              <span >
                {{setRepeatCol(data)}}
              </span>
            </template>

            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__noAnyAppointment')}}</div>
            </template>
          </Table>

        </div>
      </div>

      <div class="tabFooter">
        <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
          :range="5" @changePage="changePage"></Pagination>
      </div>
    </div>
  </div>
</section>

